// extracted by mini-css-extract-plugin
export var brand = "_77-9";
export var compact = "_77-6";
export var extraSmall = "_77-7";
export var icon = "_77-0";
export var large = "_77-4";
export var light = "_77-1";
export var medium = "_77-5";
export var outline = "_77-b";
export var primaryDark = "_77-a";
export var primaryLight = "_77-8";
export var primaryModern = "_77-c";
export var success = "_77-2";
export var successSolid = "_77-3";